import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KlarTilGodkendelseViewModel } from '../../store/models';

@Injectable({
  providedIn: 'root'
})
export class TilpasHandlingerTilGodkendelseService {
    constructor(
        private http: HttpClient
    ) { }

    getTilpasHandlingerTilGodkendelseView() {
        const url = `[api]/V2TilpasHandlinger/KlarTilGodkendelseByUser/[userid]`;
        return this.http.get<KlarTilGodkendelseViewModel[]>(url);
    }
}
